import { render, staticRenderFns } from "./PurchaseOrderDetail.vue?vue&type=template&id=368283c9"
import script from "./PurchaseOrderDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports